<template>
  <div class="w-full">
    <div>
      <button
        class="w-full flex items-center justify-between py-3 px-4 text-left font-semibold focus:outline-none"
        @click="emitToggle"
        :aria-expanded="isOpen"
      >
        <slot name="trigger" />

        <DropdownIcon
          :class="[
            'w-3 h-3 transition-transform ml-2',
            isOpen ? 'rotate-180' : '',
          ]"
        />
      </button>
      <BaseSlideTransition>
        <div v-show="isOpen">
          <div
            class="py-2 px-4 border-y border-surface-accent-light bg-surface-accent-lightest"
          >
            <slot />
          </div>
        </div>
      </BaseSlideTransition>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import DropdownIcon from '../icons/DropdownIcon.vue';
  import BaseSlideTransition from './BaseSlideTransition.vue';

  const props = defineProps<{ open?: boolean }>();
  const emit = defineEmits(['toggle']);
  const isOpen = computed(() => !!props.open);

  function emitToggle() {
    emit('toggle');
  }
</script>
